$(function() {
  $('form.ws-checkout-payment input').bind('change', function() {
    $('form.payment label.active').removeClass('active');
    $(this).parent().addClass('active');
		$('form.payment').find('label').removeClass('errors')
	});
  $('form.ws-checkout-payment').submit(function() {
		if(!$('input[name=payment_method]').is(':checked')) {
			$(this).find('label').addClass('errors');
			return false;
		}
	});

});
